import React from "react";
import { Field } from 'redux-form/immutable';
import { SelectField } from 'redux-form-antd';
import {
    required, nullValue0
} from '../../validDesc';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
}

const ClubTuesdaySelect = props => {
    const club_monday_select = [
        {
            label: '-- 請選擇 --',
            value: '0'
        },
        {
            value: '246',
            label: '4:50自接'
        },
        {
            value: '200',
            label: '安親1-2年級'
        },
        {
            value: '229',
            label: '游泳1-4年級(1.5H)'
        },
        {
            value: '232',
            label: '兒童瑜珈'
        },
        {
            value: '233',
            label: '超級街舞表演班'
        },
        {
            value: '234',
            label: '珠心算初階'
        },
        {
            value: '235',
            label: '兒童漫畫創作—【2025動畫電影藝術節】'
        },
        {
            value: '238',
            label: '英文口語訓練1-2年級'
        },
        {
            value: '240',
            label: '英文桌遊1年級'
        },
        {
            value: '241',
            label: '跆拳道'
        },
        {
            value: '242',
            label: '樂高物理機械1-3年級(1H)'
        },
        {
            value: '244',
            label: '鋼琴'
        },
        {
            value: '245',
            label: '小提琴'
        },
    ]
    const club_tuesday_display_options = club_monday_select.map(item => (
        item.value === '0' ? item : { ...item, label: `[${item.value}]${item.label}` }
    ));
    return (
        <div>
             <Field {...formItemLayout} validate={[required, nullValue0]} component={SelectField} label="星期二"
                options={club_tuesday_display_options} name="club_tuesday" type="text"></Field>
        </div>
    )
}

export default ClubTuesdaySelect



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/StudentClubForm/ClubTuesdaySelect.jsx